<template>
    <div class="container flex-grow mx-auto">
  <div class="flex flex-col min-h-full w-full">
    <div class="flex w-full laptop:w-2/3 self-center bg-white tablet:mt-5">
        <div class="flex flex-col w-full laptop:w-3/4">
            <h1 class="text-2xl text-center tablet:text-left font-medium">Quick SMS</h1>
            <div class="flex flex-col mt-5">
                <label class="text-lg">Destinations <strong class="font-light text-sm">(One number per line)</strong></label>
                <textarea type="number" class="rounded p-2 border h-14 laptop:h-56"
                v-model='form.to'
                placeholder="324617xxxx" inputmode="tel"
                 />
            </div>
            <div class="hidden tablet:block flex flex-col mt-5">
                <label class="text-sm tablet:text-lg mr-2">Upload csv or txt file <strong class="font-light text-xs"></strong></label>
                <input type="file"
                @change="fileProcess"
                />
            </div>
            <div class="flex flex-col mt-5 relative">
                <span class="absolute bottom-0 mr-5 text-gray-500 text-sm z-50 right-0">
                    <span v-if="form.unicode">Unicode </span> {{characters}}/{{max_characters}} 
                </span>
                <p class="text-lg">Message body</p>
                <textarea placeholder="message body"
                v-model="form.message"
                :maxlength="max_characters"
                @keyup='detectUnicode'
                class="h-32 p-2 rounded border"
                />
            </div>
            <div class="flex flex-col mt-5 tablet:mt-5">
                <button href="#"
                @click="sendSMS"
                :disabled='buttonDisable'
                class="bg-blue text-center py-2 rounded text-white">Send</button>
            </div>
        </div>
        <div class="text-center hidden rounded shadow p-5 tablet:block flex flex-col bg-white-light ml-5 w-1/4">
            Details regarding cost goes here <p class="text-sm mt-5"> (Work in progress)</p>
        </div>
    </div>
  </div>
    </div>
</template>

<script>
import smsSender from '@/sms'

export default {
    name: 'sms.quick',
    components: {

    },
    data(){
        return {
            form: {
                to: '',
                message: '',
                unicode: false,
                file: ''
            },
            maxlength: 10,
            buttonDisable: false
        }
    },
    methods: {
        fileProcess(event) {
            try {
                const reader = new FileReader()
                const file = event.target.files[0]
                const ext = file.name.split('.').pop().toLowerCase()
                let result
                let that = this
                reader.readAsText(file)

                reader.onload = function(){
                    that.formatContent(reader.result, ext)         
                }
                
            }
            catch (e) {
                return e
            }
            
        },
        formatContent(content, type) {
            let data
            switch (type) {
            case 'txt':
                //TODO: format numbers to E164
                data = content.split('\n')
                break
                        
            case 'csv':
                data = content.split(';')
                break
                
            default:
                
                break;
            }

            //format number
            this.form.to = this.formatNumber(data, '0')

        },
        formatNumber(data, prefix) {
            let response = ''

            data.forEach((item) => {
                if (item.startsWith(prefix)) {
                    let temp = item.slice(1)
                    response += `32${temp}\n`
                }
                else {
                    response += `${item}\n`
                }
            })

            return response

        },
        async sendSMS() {
            try {
                this.buttonDisable = true
                this.$Progress.set(50)
                const to = this.form.to.split('\n').filter(Boolean)
                await smsSender({
                    to: to,
                    message: this.form.message,
                    unicode: this.form.unicode
                })

                this.$Progress.finish()
                this.$notify({
                    group: 'nomado',
                    text: 'All sms successfully sent.'
                })
                this.buttonDisable = false
                

            } catch (error) {
                this.buttonDisable = false
                this.$notify({
                    group: 'nomado',
                    type: 'error',
                    title: 'SMS sending failed',
                    text: 'Please ensure there is atleast one valid number in destinations. <br />. Message cannot be empty.'
                })
                
            }
        },
        detectUnicode() {
            // test d'accent éàéîûôéçàôûîôôôöüûéàëêôû test d'accents ûîôîôêëöëöîöïêë¨ààä€€àà@@ààêôîïöëüû fin de test d'accent.
            this.form.unicode = this.isUnicode(this.form.message)
        },
        isUnicode(char) {
            var regexp = new RegExp("^[A-Za-z0-9 \\r\\n@£$¥èéùìòÇØøÅå\u0394_\u03A6\u0393\u039B\u03A9\u03A0\u03A8\u03A3\u0398\u039EÆæßÉ!\"#$%&'()*+,\\-./:;<=>?¡ÄÖÑÜ§¿äöñüà^{}\\\\\\[~\\]|\u20AC]*$");

            return !regexp.test(char)
        },
        getMessageMAXLength(message){
            let message_max_length = (this.form.unicode === false)
                ? 1377
                : 603

            switch (this.unicode) {
            case false:
                if(this.form.message.length > 160){
                    message_max_length = 153 * 9
                    break;
                }
                break;

            case true:
                if(this.form.message.length > 70){
                    message_max_length = 67 * 9
                    break;
                }
                break;

            default:
                break;
            }
            return message_max_length
        }
    },
    computed: {
        characters() {
            let count = 0
            for(let index=0; index < this.form.message.length; index++){
                let n = (this.isUnicode(this.form.message.charAt(index))) ? 2 : 1
                count = count + n

            }
            return count
        },
        max_characters() {
            return this.getMessageMAXLength(this.message)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
